const ITEMS = [
  ["Virrey del Pino", "Santiago del Estero", "15:10"],
  ["Retiro", "Tucumán", "19:00"],
  ["Liniers", "Frías", "17:55"],
  ["Retiro", "Nueva Esperanza", "19:00"],
  ["Retiro", "Monte Quemado", "19:00"],
  ["Tucumán", "Retiro", "15:10"],
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map(([a, b, t], i) => (
      <span key={i} className="flex items-center gap-5 px-8 font-display text-2xl text-white md:text-4xl">
        {a}
        <span className="text-[var(--lime)]">→</span>
        {b}
        <span className="font-mono text-sm not-italic font-normal tracking-widest text-[var(--lime)] md:text-base">{t}</span>
        <span className="ml-6 inline-block h-3 w-3 rounded-full bg-[var(--lime)]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="departures-marquee" className="relative overflow-hidden border-y border-white/10 bg-[var(--ink)] py-6 md:py-8">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);
